var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 0C0 0.676923 0.553846 1.23077 1.23077 1.23077H1.41538L6.15385 8.49231V14.7692L9.84615 12.3077V8.49231L14.5846 1.23077H14.7692C15.4462 1.23077 16 0.676923 16 0H0ZM8.61559 11.6307L7.38482 12.4307V8.61528H8.61559V11.6307ZM6.89213 7.38482H9.10751L13.1075 1.23097H2.89213L6.89213 7.38482Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.50304d5ec05eb977b5527805ff7ef844.svg";
export { ForwardRef as ReactComponent };